export default __webpack_public_path__ + "static/media/151-kilograms.8c2e44cd.png";